import { Component, OnInit } from '@angular/core';
import { TreeNode } from '@circlon/angular-tree-component';
import { BranchService } from '../shared/services/branch.service';
import { Branch } from "../Models/branch";
import { MessageBox } from '../shared/message-box/message-box';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';





//const actionMapping: IActionMapping = {
//  mouse: {
//    contextMenu: (tree, node, $event) => {
//      $event.preventDefault();
//      alert(`context menu for ${node.data.name}`);
//      tree = tree;
//    },
//    dblClick: (tree, node, $event) => {
//      if (node.hasChildren) {
//        TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);

//      }
//    },
//    click: (tree, node, $event) => {
//      $event.shiftKey
//        ? TREE_ACTIONS.TOGGLE_SELECTED_MULTI(tree, node, $event)
//        : TREE_ACTIONS.TOGGLE_SELECTED(tree, node, $event);
//    },
//  },
//  keys: {
//    [KEYS.ENTER]: (tree, node, $event) => { TREE_ACTIONS.TOGGLE_SELECTED(tree, node, $event); },
//    [KEYS.LEFT]: (tree, node, $event) => {
//      if (node.hasChildren) {
//        TREE_ACTIONS.TOGGLE_EXPANDED(tree, node, $event);
//      }
//    },
//    [KEYS.RIGHT]: (tree, node, $event) => { TREE_ACTIONS.COLLAPSE(tree, node, $event); }


//  }
//};


@Component({
  selector: 'branchsearch',
  templateUrl: './branch-dialog.component.html',
  styleUrls: ['./branch-dialog.component.scss'],
  providers: [BranchService, MessageBox]
})
export class BranchDialogComponent implements OnInit {
  public nodes: any[];

  constructor(public dialogRef: MatDialogRef<BranchDialogComponent>,
    private branchService: BranchService, private router: Router,
    private messageBox: MessageBox) { }

  nodes2 = [{ name: 'root' }, { name: 'root2' }];
  NodeItems: any[];
  nodesTmp: any[];
  selected: string[] = [];
  branchId: number;
  Selectedbranche: Branch[] = [];
  // family: Family = new Family();
  selectedBranchId: number;
  changeBranchList(barnch: Branch, checked: boolean) {
    if (checked) {
      this.Selectedbranche.push(barnch);
    }
    else {
      let sss = this.Selectedbranche.indexOf(barnch);
      this.Selectedbranche.splice(sss, 1);
    }

  }

  asyncChildren = [
    {
      name: 'child2.1',
      subTitle: 'new and improved'
    }, {
      name: 'child2.2',
      subTitle: 'new and improved2'
    }
  ];





  customTemplateStringOptions = {
    // displayField: 'subTitle',
    //isExpandedField: 'expanded',
    idField: 'uuid',
    getChildren: this.getChildren.bind(this),
    allowDrag: true,
    allowDrop: true,
    useVirtualScroll: false,

  };

  Target = new Array<Branch>();
  private TreeViewGenerateNodes(ParentID: number): Array<Branch> {
    var FilterData = this.NodeItems.filter(XX => XX.parentId === ParentID);
    var temp = new Array<Branch>();
    for (let NodeItem of FilterData) {

      var FilterData2 = this.NodeItems.filter(XX => XX.parentId === NodeItem.branchId);
      var branchTMP = new Branch();
      branchTMP.parentId = NodeItem.parentId;
      branchTMP.name = NodeItem.name;
      branchTMP.branchId = NodeItem.branchId;
      branchTMP.canInsertSubBranch = NodeItem.canInsertSubBranch;
      if (FilterData2.length > 0) {
        branchTMP.hasChildren = true;
        branchTMP.children = new Array<Branch>();
        var children = this.TreeViewGenerateNodes(branchTMP.branchId);
        for (let child of children) {
          branchTMP.children.push(child);
        }
      }
      if (NodeItem.parentId == null) {
        this.Target.push(branchTMP);
      }
      temp.push(branchTMP);
    }

    return temp;

  }
  deleted: boolean;




  ngOnInit() {
    this.branchService.getBranches()
      .subscribe(result => {
        if (result.successful == false) {
          this.messageBox.showError("خطا", result.response);
        } else {
          this.NodeItems = result.returnValue;
          this.TreeViewGenerateNodes(null);
          this.nodes = this.Target;
        }
      });

  }


  getChildren(node: any) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(this.asyncChildren.map((c) => {
        return Object.assign({}, c, {
          hasChildren: node.level < 5
        });
      })), 1000);
    });
  }



  childrenCount(node: TreeNode): string {
    return node && node.children ? `(${node.children.length})` : '';
  }

  filterNodes(text, tree) {
    if (text.length > 2 || text.length == 0) {
      tree.treeModel.filterNodes(text);
    }
  }

  activateSubSub(tree) {
    // tree.treeModel.getNodeBy((node) => node.data.name === 'subsub')
    tree.treeModel.getNodeById(1001)
      .setActiveAndVisible();
  }

  onEvent(event) {
    console.log(event);
  }

  activeNodes(treeModel) {
    console.log(treeModel.activeNodes);
  }

  public edit(branchId: number): void {
    this.router.navigate(['/admin/security/branchedit', branchId]);
  }






}
